<template>
  <div class="module-header ms-main-head">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less">
.module-header {
  margin-bottom: 16px;
}
</style>
